import * as React from "react";
import { getDate } from "src/utils/dateUtils";

interface TimelineItemProps {
  isOpen: boolean;
  onToggle: () => void;
  date: string;
  children: React.ReactNode;
}

const TimelineItem: React.FC<TimelineItemProps> = ({ isOpen, onToggle, date, children }) => (
  <li className="timeline-item w-100 py-0" style={{ marginLeft: "14px" }}>
    <button
      type="button"
      className={`btn btn-collapse d-flex justify-content-between p-0 align-items-center w-100 mb-4 ${
        isOpen ? "" : " collapsed"
      }`}
      onClick={onToggle}
    >
      <div className="d-flex align-items-center justify-content-between w-100">
        <div className="d-flex flex-column text-start gap-2">
          <span className="timeline-day fs-14 fw-semibold">
            {getDate(date).toLocaleDateString("en-US", { weekday: "long" })}
          </span>
          <span className="timeline-date fs-26 fw-semibold">{date}</span>
        </div>
        <span className="icon icon-xl text-secondary">{isOpen ? "expand_less" : "expand_more"}</span>
      </div>
    </button>
    <div className={`collapse ${isOpen ? " show" : ""} mb-4`}>{children}</div>
  </li>
);

export default TimelineItem;
